var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlastic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.133,
    height: 32,
    viewBox: "0 0 50.133 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 50.133,
    height: 32,
    rx: 4,
    transform: "translate(-0.181 0.059)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    width: 50.133,
    height: 32,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28562",
    "data-name": "Group 28562",
    transform: "translate(0.181 -0.059)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28561",
    "data-name": "Group 28561",
    transform: "translate(-0.18 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32079",
    "data-name": "Path 32079",
    d: "M0,0H49.92V32.587H0Z",
    transform: "translate(0.175)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28557",
    "data-name": "Group 28557",
    transform: "translate(0 0.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28556",
    "data-name": "Group 28556",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28555",
    "data-name": "Group 28555",
    transform: "translate(-3.343 -21.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32080",
    "data-name": "Path 32080",
    d: "M139.708-33.187,120.455-67.32l19.253-34.133L158.962-67.32Z",
    transform: "translate(-94.287 101.453)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3099",
    "data-name": "Ellipse 3099",
    cx: 20.26,
    cy: 21.004,
    rx: 20.26,
    ry: 21.004,
    transform: "translate(0 30.133)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32081",
    "data-name": "Path 32081",
    d: "M133.779,72.927a21.686,21.686,0,0,0,1.027-6.618,21.008,21.008,0,0,0-12.9-19.575l-1.45,2.571Z",
    transform: "translate(-94.287 -15.172)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlastic);
export default __webpack_public_path__ + "static/media/plastic.6ef69234f000d90f15a4a498d6ceea18.svg";
export { ForwardRef as ReactComponent };